import { lazy } from 'react';

const OwneropAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/ownerops',
      component: lazy(() => import('./NewSubcontractor/Subcontractors')),
    },
    
  ],
};

export default OwneropAppConfig;
